import React from 'react';
import { Toaster, ToastBar, toast } from 'react-hot-toast';
import { X } from 'lucide-react';

/**
 * Site-wide toast host. Adds a dismiss (×) control to every notification
 * without changing individual toast.success / toast.error call sites.
 */
function AppToaster() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: '#363636',
          color: '#fff',
        },
        success: {
          style: {
            background: '#00D4AA',
          },
        },
        error: {
          style: {
            background: '#EF4444',
          },
        },
      }}
    >
      {(t) => (
        <ToastBar toast={t} className="!relative">
          {({ icon, message }) => (
            <>
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toast.dismiss(t.id);
                }}
                className="absolute right-2 top-2 z-10 rounded p-0.5 text-white/90 transition-colors hover:bg-white/20 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
                aria-label="Close notification"
              >
                <X className="h-4 w-4" strokeWidth={2} aria-hidden />
              </button>
              {icon}
              <span className="min-w-0 flex-1 pr-6">{message}</span>
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}

export default AppToaster;
